import { useEffect, useState } from "react";
import StartScreen from "./Components/StartScreen";
import Board from "./Components/Board";

function App() {
  const [fourGrid, setFourGrid] = useState([
    "10",
    "11",
    "20",
    "21",
    "30",
    "31",
    "40",
    "41",
    "50",
    "51",
    "60",
    "61",
    "70",
    "71",
    "80",
    "81",
  ]);

  const [sixGrid, setSixGrid] = useState([
    "10",
    "11",
    "20",
    "21",
    "30",
    "31",
    "40",
    "41",
    "50",
    "51",
    "60",
    "61",
    "70",
    "71",
    "80",
    "81",
    "90",
    "91",
    "100",
    "101",
    "110",
    "111",
    "120",
    "121",
    "130",
    "131",
    "140",
    "141",
    "150",
    "151",
    "160",
    "161",
    "170",
    "171",
    "180",
    "181",
  ]);

  const [theme, setTheme] = useState("Numbers");
  const [players, setPlayers] = useState(["1"]);
  const [grid, setGrid] = useState("4x4");

  const [gameActive, setGameActive] = useState(false);

  function startGame() {
    setGameActive(!gameActive);
  }

  let shuffled4 = fourGrid
    .map((value) => ({ value, sort: Math.random() }))
    .sort((a, b) => a.sort - b.sort)
    .map(({ value }) => value);

  let shuffled6 = sixGrid
    .map((value) => ({ value, sort: Math.random() }))
    .sort((a, b) => a.sort - b.sort)
    .map(({ value }) => value);

  return (
    <div className="App">
      <StartScreen
        theme={theme}
        setTheme={setTheme}
        players={players}
        setPlayers={setPlayers}
        grid={grid}
        setGrid={setGrid}
        gameActive={gameActive}
        startGame={startGame}
      />
      <Board
        theme={theme}
        players={players}
        grid={grid === "4x4" ? "4x4" : "6x6"}
        gridArray={grid === "4x4" ? shuffled4 : shuffled6}
        gameActive={gameActive}
        setGameActive={setGameActive}
        setPlayers={setPlayers}
      />
    </div>
  );
}

export default App;
